const scopedStore = (uri, data = {}) => ({
    properties: {},
    iterrableData: [],
    loading: true,
    async init() {
        this.reset()

        if (Object.keys(data).length > 0) {
            this.assignData(data)

            return
        }

        this.assignData(await window.api.get(uri).then((result) => result.data))
    },
    assignData(gatheredData) {
        if ('data' in gatheredData) {
            this.iterrableData = gatheredData.data
        } else {
            this.iterrableData = gatheredData
        }

        this.properties = gatheredData
        this.loading = false
    },
    reset() {
        this.properties = {}
        this.iterrableData = []
        this.loading = true
    },
})
document.addEventListener('alpine:init', () => {
    window.Alpine.data('scopedStore', scopedStore)
})
